import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  Switch,
  Typography,
  IconButton,
} from "@mui/material";

import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CloseIcon from "@mui/icons-material/Close";

function AddCategoryModal({ open, onClose, onSave }) {
  const [form, setForm] = useState({
    textFr: "",
    textEn: "",
    estActif: true,
    image: null,
    preview: null,
  });

  const [errors, setErrors] = useState({});

  // ================= INPUT =================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ================= IMAGE =================
  const handleImage = (file) => {
    if (!file) return;

    setForm({
      ...form,
      image: file,
      preview: URL.createObjectURL(file),
    });
  };

  // ================= DROP =================
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleImage(file);
  };

  // ================= VALIDATION =================
  const validate = () => {
    let err = {};

    if (!form.textFr) err.textFr = "Champ requis";
    if (!form.textEn) err.textEn = "Champ requis";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // ================= SUBMIT =================
  const handleSubmit = () => {
    if (!validate()) return;

    onSave(form);

    // reset
    setForm({
      textFr: "",
      textEn: "",
      estActif: true,
      image: null,
      preview: null,
    });

    setErrors({});
  };

  // ================= cancel =================
  const handleCancel = () => {
    setForm({
      textFr: "",
      textEn: "",
      estActif: true,
      image: null,
      preview: null,
    });

    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">

      {/* ================= HEADER ================= */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
          backgroundColor: "#FFBC0F",
          color: "white",
        }}
      >
        Ajouter une catégorie

        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: "white" }} />
        </IconButton>
      </DialogTitle>

      {/* ================= CONTENT ================= */}
      <DialogContent sx={{ p: 3 }}>

        {/* FR */}
        <TextField
          fullWidth
          margin="dense"
          label="Nom FR"
          name="textFr"
          value={form.textFr}
          onChange={handleChange}
          error={!!errors.textFr}
          helperText={errors.textFr}
        />

        {/* EN */}
        <TextField
          fullWidth
          margin="dense"
          label="Nom EN"
          name="textEn"
          value={form.textEn}
          onChange={handleChange}
          error={!!errors.textEn}
          helperText={errors.textEn}
        />

        {/* ACTIF */}
        <Box mt={2} display="flex" alignItems="center" gap={2}>
          <Typography>Actif</Typography>
          <Switch
            checked={form.estActif}
            onChange={(e) =>
              setForm({ ...form, estActif: e.target.checked })
            }
          />
        </Box>

        {/* ================= IMAGE UPLOAD ================= */}
        <Box
          mt={3}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onClick={() => document.getElementById("fileInput").click()}
          sx={{
            border: "2px dashed #ccc",
            borderRadius: 3,
            p: 3,
            textAlign: "center",
            cursor: "pointer",
            backgroundColor: "#fafafa",
            transition: "0.2s",
            "&:hover": {
              backgroundColor: "#f0f0f0",
              borderColor: "#999",
            },
          }}
        >
          <AddPhotoAlternateIcon sx={{ fontSize: 40, color: "#999" }} />

          <Typography fontSize={13} mt={1}>
            Clique ou glisse une image ici
          </Typography>

          {/* FILE INPUT */}
          <input
            id="fileInput"
            type="file"
            hidden
            accept="image/*"
            onChange={(e) =>
              handleImage(e.target.files[0])
            }
          />

          {/* PREVIEW */}
          {form.preview && (
            <Box mt={2}>
              <img
                src={form.preview}
                alt="preview"
                style={{
                  width: "100%",
                  maxHeight: 180,
                  objectFit: "cover",
                  borderRadius: 10,
                  border: "1px solid #ddd",
                }}
              />
            </Box>
          )}
        </Box>

        {/* ================= BUTTON ================= */}
        <Box
          display="flex"
          justifyContent="space-between"
          mt={3}
          gap={2}
        >
          {/* CANCEL */}
          <Button
            fullWidth
            variant="outlined"
            color="inherit"
            onClick={handleCancel}
          >
            Annuler
          </Button>

          {/* SUBMIT */}
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#FFBC0F",
              fontWeight: 600,
            }}
            onClick={handleSubmit}
          >
            Ajouter la catégorie
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AddCategoryModal;